import globalMU from 'globalMU'
const ko = require('knockout')
import store from 'app/redux/store/store'
import {atualizarItemAction} from "../../redux/orcamentoSlice";
import { alterarPrecoItem } from 'app/use-cases';
import {IItemOrcamento} from "../../types/IItemOrcamento";
import {definirPreservaDesconto} from "../../use-cases/orcamento/definirPreservaDesconto";
import { obterItemOrcamentoDaStore } from 'app/redux/utils/obterItemOrcamentoDaStore';
import { th } from 'date-fns/locale';
import { obterParametro } from 'app/use-cases/parametro/obterParametro';

declare var window:any

var sim = 0;

const SimularDescontoItemOrcamentoController = ObjectBase.extend({
    initialize: function() {
        this.id = ++sim;
        this.executarSubscriber = true;
        this.preservaDescontoModificadoManualmente = false
        
    },

    show: async function () {
        try {
            globalMU.blockUI({tryPassiveLoading: false})

            var self = this;
            if (!this.modal || !this.model) {
                return;
            }
            this.$modal = $(this.modal);

            if (!this.$modal || this.$modal.length == 0) {
                return;
            }

            const itemOrcamentoDaStore = obterItemOrcamentoDaStore(this.model.Identificador)
            this.model.PercentualDescontoTotal = itemOrcamentoDaStore?.PercentualDesconto; // FNX-5324
            this.model.PercentualComissao = 0;
            this.model.Comissao = 0;
            this.model.PreservaDesconto = itemOrcamentoDaStore?.PreservaDesconto
            

            this.model = ko.mapping.fromJS(this.model);
            this.controller.applyBindings(this, this.$modal[0]);

            this.percentualDescontoAnterior = this.model.PercentualDesconto()

            this.iniciarSubscribers();

            this.$modal.modal();

            $("#SimularDesconto_PercentualDesconto").focus()
            $("#SimularDesconto_PercentualDesconto").select()

            const simularDescontoItemOrcamentoResposta = await globalMU.ajax({
                url: "/Orcamento/SimularDescontoItemOrcamento",
                type: "post",
                blockUI: false,
                async: false,
                contentType: "application/json",
                data: JSON.stringify({
                    identificadorOrcamento: this.model.IdentificadorOrcamento(),
                    codigoObjetoItem: this.model.Identificador(),
                    preco: globalMU.unformatNumber(this.model.PrecoProduto()),
                    preservaDesconto: this.model.PreservaDesconto(),
                    percentualDesconto: globalMU.unformatNumber(this.model.PercentualDesconto()),
                    percentualBonificacao: parseInt(globalMU.unformatNumber(this.model.PercentualBonificacao())),
                    percentualDescontoGeralOrcamento: this.itemOrcamento.orcamento.attributes.PercentualDesconto
                })
            })

            if (simularDescontoItemOrcamentoResposta != null) {
                self.alterarPercentualComissao(simularDescontoItemOrcamentoResposta)
            }

        } finally {
            globalMU.unblockUI()
        }


    },

    alterarPercentualComissao: function (val) {
        this.model.PercentualComissao(val.PercentualComissao)
        this.model.Comissao(val.Comissao)
        this.model.PercentualDescontoTotal(val.PercentualDescontoTotal)
    },

    alterarPreservaDesconto: async function () {

        this.preservaDescontoModificadoManualmente = true

        // await this.simular(
        //     null //preco
        //     , globalMU.unformatNumber(this.model.PercentualDesconto()) //percentualDesconto
        //     , globalMU.unformatNumber(this.model.PercentualBonificacao()) //percentualBonificacao
        //     , this.model.PreservaDesconto() //preservaDesconto
        // )

    },

    iniciarSubscribers: function() {
        $("#SimularDesconto_PreservaDesconto").on('change', () => this.alterarPreservaDesconto())
        this.model.PercentualDesconto.subscribe($.proxy(this.alterarPercentualDesconto, this));
        this.model.PercentualBonificacao.subscribe($.proxy(this.alterarPercentualBonificacao, this));
        this.model.PrecoProduto.subscribe($.proxy(this.alterarPrecoProduto, this));

        $("input").on('focus', function () { $(this).select(); });
    },

    alterarPercentualDesconto: async function() {

        if (!this.executarSubscriber || this.model.PercentualDesconto() == this.percentualDescontoAnterior) {
            return;
        }

        this.percentualDescontoAnterior = this.model.PercentualDesconto()

        if (globalMU.unformatNumber(this.model.PercentualDesconto()) > 0 && !this.preservaDescontoModificadoManualmente)  {
            this.model.PreservaDesconto(true)
        } else if (globalMU.unformatNumber(this.model.PercentualDesconto()) == 0 && !this.preservaDescontoModificadoManualmente) {
            this.model.PreservaDesconto(false)
        }

        await this.simular(
            null //preco
            , globalMU.unformatNumber(this.model.PercentualDesconto()) //percentualDesconto
            , globalMU.unformatNumber(this.model.PercentualBonificacao()) //percentualBonificacao
            , this.model.PreservaDesconto() //preservaDesconto
        )

        // this.model.PreservaDesconto(!this.model.PreservaDesconto())
        // $("#SimularDesconto_PreservaDesconto").prop('checked', preservaDesconto)
    },

    alterarPercentualBonificacao: function (value) {

        if (!this.executarSubscriber || value == this.ultimoPercentualBonificacao) {
            return;
        }

        this.ultimoPercentualBonificacao = parseInt(value);

        this.simular(null, globalMU.unformatNumber(this.model.PercentualDesconto()), globalMU.unformatNumber(this.model.PercentualBonificacao()), this.model.PreservaDesconto());
    },

    alterarPrecoProduto: function(value) {
        if (!this.executarSubscriber || value == this.ultimoPreco) {
            return;
        }

        this.ultimoPreco = value;

        $("#SimularDesconto_PreservaDesconto").prop('checked', Number(globalMU.unformatNumber(value)) < this.model.PrecoUnitarioTabela())
        this.simular(globalMU.unformatNumber(this.model.PrecoProduto()), null, null, Number(globalMU.unformatNumber(value)) < this.model.PrecoUnitarioTabela());
    },

    simular: async function(preco, percentualDesconto, percentualBonificacao, preservaDesconto: boolean) {

        const simularDescontoItemOrcamentoResposta = await globalMU.ajax({
            url: "/Orcamento/SimularDescontoItemOrcamento",
            type: "post",
            blockUI: false,
            contentType: "application/json",
            async: false,
            data: globalMU.toJSONString({
                identificadorOrcamento: this.model.IdentificadorOrcamento(),
                codigoObjetoItem: this.model.Identificador(),
                preco: preco,
                percentualDesconto: percentualDesconto,
                percentualBonificacao: percentualBonificacao,
                percentualDescontoGeralOrcamento: this.itemOrcamento.orcamento.attributes.PercentualDesconto,
                preservaDesconto
            })
        })

        if (simularDescontoItemOrcamentoResposta != null) {
            this.atualizar(simularDescontoItemOrcamentoResposta)
        }

    },

    atualizar: function(simularDescontoItemOrcamentoResposta, limpar) {
        this.executarSubscriber = false;
        this.model.PrecoProduto(limpar ? undefined : simularDescontoItemOrcamentoResposta.Preco);
        this.ultimoPreco = simularDescontoItemOrcamentoResposta ? simularDescontoItemOrcamentoResposta.Preco : null;
        this.percentualDescontoAnterior = simularDescontoItemOrcamentoResposta?.PercentualDesconto
        this.model.PercentualDesconto(limpar ? undefined : globalMU.formatNumber(simularDescontoItemOrcamentoResposta.PercentualDesconto));
        this.model.PercentualBonificacao(limpar ? undefined : globalMU.formatNumber(simularDescontoItemOrcamentoResposta.PercentualBonificacao));
        this.model.PreservaDesconto(simularDescontoItemOrcamentoResposta ? simularDescontoItemOrcamentoResposta.PreservaDesconto : null);
        this.ultimoPercentualBonificacao = simularDescontoItemOrcamentoResposta ? simularDescontoItemOrcamentoResposta.PercentualBonificacao : null;
        this.model.DescontoPendente(limpar ? undefined : simularDescontoItemOrcamentoResposta.DescontoPendente);
        this.model.BonificacaoPendente(limpar ? undefined : simularDescontoItemOrcamentoResposta.BonificacaoPendente)
        this.model.PercentualDescontoTotal(limpar ? undefined : simularDescontoItemOrcamentoResposta.PercentualDescontoTotal) //FNX-5324
        this.model.PercentualComissao(limpar ? undefined : simularDescontoItemOrcamentoResposta.PercentualComissao)
        this.model.Comissao(limpar ? undefined : simularDescontoItemOrcamentoResposta.Comissao)
        this.model.PendenciaDescontoSobreOferta(limpar ? undefined : simularDescontoItemOrcamentoResposta.PendenciaDescontoSobreOferta)
        this.model.PreservaDesconto(simularDescontoItemOrcamentoResposta?.PreservaDesconto ?? false)
        this.executarSubscriber = true;
    },

    definirPreco: async function () {
        if (!globalMU.isFormValid("#modalSimularDesconto form", false)) {
            return;
        }
        let percentual = $("#SimularDesconto_PercentualDesconto").val() // 414407
        if (!percentual) {
            percentual = 0;
        }
        


        this.itemOrcamento.set("SimulandoDesconto", true);
        store.dispatch(atualizarItemAction({identificador: this.itemOrcamento.get("Identificador"), dados: {SimulandoDesconto: true}}))
        

        await alterarPrecoItem({
            identificadorItem: this.itemOrcamento.get("Identificador"),
            preco: this.model.PrecoProduto(),
            percentualDesconto: this.model.PercentualDesconto(),
            percentualBonificacao: this.model.PercentualBonificacao(),
            atualizarEstadoLegadoImediatamente: true,
            itemLegado: this.itemOrcamento
        })

        const parametro_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO = await obterParametro({nome: "PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO"})

        if (parametro_PERMITIR_PRESERVAR_DESCONTO_ITEM_ORCAMENTO == "S") {
            await definirPreservaDesconto({
                identificadorItem: this.model.Identificador(),
                preservaDesconto: this.model.PreservaDesconto()
            })
        }
        
        this.itemOrcamento.set("PrecoProduto", this.model.PrecoProduto(), {silent: true});
        this.$modal.modal("hide");
        $("#PreservaDesconto").prop('checked', $("#SimularDesconto_PreservaDesconto").prop('checked'))
    }
});

window.SimularDescontoItemOrcamentoController = SimularDescontoItemOrcamentoController

export {
    SimularDescontoItemOrcamentoController
}
